/* Approved picker presentation. No cart writes, price overrides, or tracking changes. */
(() => {
  'use strict';
  const configNode = document.getElementById('steadi-sale-picker-config');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  if (!document.getElementById('steadi-live-picker') && !window.Shopify?.designMode) return;
  const money = value => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value / 100);
  const mounted = new WeakSet();
  const css = `
:host([data-sale-picker]){--pale:#f0f6f3;--line:#dbe3df;--muted:#63726b}
:host([data-sale-picker]) .store-strip{display:none}
:host([data-sale-picker]) .picker{max-width:1390px;padding:26px 4vw 42px;column-gap:50px;row-gap:24px;grid-template-columns:minmax(0,1.04fr) minmax(0,1fr);grid-template-areas:'visual heading' 'visual pack' 'visual controls';align-items:start}
:host([data-sale-picker]) .product-heading .eyebrow{font-size:10px;letter-spacing:1.8px;color:#587166}
:host([data-sale-picker]) .product-heading .product-title{font-size:46px;letter-spacing:-2px;margin:10px 0 11px;line-height:1.06;font-weight:750}
:host([data-sale-picker]) .sale-picker-intro{font-size:14px;line-height:1.5;color:#5c6e64;margin:0}
:host([data-sale-picker]) .rating{margin:15px 0 0;font-size:12px;gap:10px}
:host([data-sale-picker]) .rating>span{font-size:16px;color:#254c40}
:host([data-sale-picker]) .sale-picker-offer{background:#ffe1eb;border:1px solid #efb5c8;border-radius:10px;margin-top:25px;padding:16px 17px;display:flex;align-items:center;justify-content:space-between;gap:14px}
:host([data-sale-picker]) .sale-picker-offer>div:first-child{display:flex;align-items:center;gap:12px}
:host([data-sale-picker]) .sale-picker-badge{display:flex;align-items:center;justify-content:center;flex:none;background:white;color:#254c40;border:1px solid #ccddd1;border-radius:6px;font-size:12px;font-weight:750;line-height:1;padding:11px 8px}
:host([data-sale-picker]) .sale-picker-copy{display:grid;gap:6px}
:host([data-sale-picker]) .sale-picker-copy b{font-size:13px}
:host([data-sale-picker]) .sale-picker-copy small{font-size:10px;color:#4e6458}
:host([data-sale-picker]) .sale-picker-deadline{display:grid;justify-items:end;gap:4px;flex:none}
:host([data-sale-picker]) .sale-picker-deadline>b{font-size:10px;font-weight:650}
:host([data-sale-picker]) .sale-picker-deadline>small{font-size:8px;color:#4e6458}
:host([data-sale-picker]) .sale-picker-countdown{font-size:12px;font-weight:600;color:#466451;font-variant-numeric:tabular-nums;white-space:nowrap}
:host([data-sale-picker]) .pack-section legend{margin-bottom:20px;font-size:16px;display:flex;align-items:center;gap:9px;width:100%}
:host([data-sale-picker]) .sale-picker-pack-note{font-size:10px;font-weight:400;margin-left:auto;color:#63756a}
:host([data-sale-picker]) .step-number{width:23px;height:23px;border-color:#bccfc1}
:host([data-sale-picker]) .pack-options{gap:10px;grid-template-columns:repeat(3,minmax(0,1fr))}
:host([data-sale-picker]) .pack-option{display:flex;flex-direction:column;padding:0!important;min-height:0;gap:0;border:1px solid #ccd8d0;border-radius:10px;background:#fff;transition:border-color .15s,background .15s;isolation:isolate;min-width:0}
:host([data-sale-picker]) .pack-option:has(input:checked){padding:0!important;border:1px solid #254c40;box-shadow:0 0 0 1px #254c40;background:#f4f8f5}
:host([data-sale-picker]) .pack-option:hover{border-color:#658774}
:host([data-sale-picker]) .sale-pack-content{display:flex;flex-direction:column;padding:17px 13px 14px;min-width:0;flex:1}
:host([data-sale-picker]) .pack-option .pack-top{font-size:17px;font-weight:700;line-height:1.3;gap:5px}
:host([data-sale-picker]) .pack-check{font-size:15px;color:#254c40}
:host([data-sale-picker]) .pack-use{font-size:10px;color:#617267;margin:7px 0 0;line-height:1.4;white-space:nowrap;min-height:0}
:host([data-sale-picker]) .sale-former-price{font-size:18px;line-height:1.35;font-weight:550;letter-spacing:0;min-height:0;color:#b42332;margin:21px 0 4px;white-space:nowrap}
:host([data-sale-picker]) .sale-former-price s{position:relative;display:inline-block;text-decoration:none;white-space:nowrap}:host([data-sale-picker]) .sale-former-price s::after{content:"";position:absolute;left:-3%;top:50%;width:106%;height:1.5px;background:currentColor;transform:rotate(-12deg);transform-origin:center;pointer-events:none}
:host([data-sale-picker]) .pack-pricing{display:block;min-height:0!important;font-size:33px;line-height:1.05;font-weight:750;letter-spacing:-1.1px;margin:0}
:host([data-sale-picker]) .pack-price{font:inherit;display:block;color:#202d2b;margin:0;white-space:nowrap}
:host([data-sale-picker]) .pack-upgrade{display:none}
:host([data-sale-picker]) .unit-price{font-size:11px;line-height:1.5;margin:8px 0 0;color:#586e60;white-space:nowrap}
:host([data-sale-picker]) .sale-pack-saving{border-top:1px solid #dce7df;border-radius:0 0 9px 9px;text-align:center;color:#2a5941;font-size:12px;font-weight:650;padding:10px 5px;background:#edf4ef;margin:0;display:block}
:host([data-sale-picker]) .pack-option:has(input:checked) .sale-pack-saving{color:#fff;background:#254c40;border-color:#254c40}
:host([data-sale-picker]) .value-badge{top:-10px;right:11px;left:auto;background:#e6eee7;border:1px solid #d2dfd4;padding:4px 7px;font-size:9px;line-height:1;border-radius:4px;letter-spacing:.1px}
:host([data-sale-picker]) .pack-foot{padding:16px 0 0!important;min-height:0;gap:8px;align-items:center;font-size:11px}
:host([data-sale-picker]) #savings{margin:0!important;max-width:none;text-align:left!important;font-size:11px;line-height:1.5;color:#355847!important}
:host([data-sale-picker]) .sale-shipping-icon{flex:none;width:19px;height:19px;color:#355847}
:host([data-sale-picker]) .visual-column{position:sticky!important;top:108px!important;padding-top:0;align-self:start;height:auto;min-height:0}
:host([data-sale-picker]) .visual-column .set-card{border-radius:14px;min-height:0;height:auto;width:100%;aspect-ratio:1;background:#f1f5f2}
:host([data-sale-picker]) .visual-column .set-card-top{font-size:11px;padding:18px;min-height:0}
:host([data-sale-picker]) .visual-column .live-indicator{font-size:10px}
:host([data-sale-picker]) .visual-column .set-card-bottom{padding:14px 15px}
:host([data-sale-picker]) .visual-column .set-card-bottom p{font-size:11px;padding:7px 13px}
:host([data-sale-picker]) .visual-column>.mode-options{margin:12px 0 0;min-height:0}
:host([data-sale-picker]) .mode-options{background:#f6f8f6}
:host([data-sale-picker]) .mode-options button{font-size:12px;font-weight:650;min-height:42px}
:host([data-sale-picker]) .sale-picker-photo-note{font-size:10px;text-align:center;color:#6d776f;margin:12px 0 0;line-height:1.5}
:host([data-sale-picker]) .controls .color-section{border-top:1px solid #dbe3df;padding-top:23px}
:host([data-sale-picker]) .color-section h2{font-size:16px;margin:0 0 20px}
:host([data-sale-picker]) .no-extra{font-size:10px}
:host([data-sale-picker]) .palette-heading{font-size:12px;margin-bottom:18px}
:host([data-sale-picker]) .palette-heading>b{font-size:12px}
:host([data-sale-picker]) .palette{gap:22px 8px}
:host([data-sale-picker]) .swatch{font-size:11px;min-height:0;gap:10px}
:host([data-sale-picker]) .swatch-color{width:44px;height:44px}
:host([data-sale-picker]) .color-sets{margin-top:26px}
:host([data-sale-picker]) .preset-heading{font-size:12px}
:host([data-sale-picker]) .color-sets .preset{font-size:11px}
:host([data-sale-picker]) .engraving{background:#f8faf8}
:host([data-sale-picker]) .engrave-example{background:#f0f5f2}
:host([data-sale-picker]) .engraving summary{padding:20px 16px}
:host([data-sale-picker]) .order-summary b{font-size:18px}
:host([data-sale-picker]) [data-sale-hidden]{display:none!important}
:host([data-sale-picker][data-sale-active="false"]) .pack-pricing{margin-top:24px}
@container(min-width:701px) and (max-width:1100px){
 :host([data-sale-picker]) .picker{column-gap:28px;padding-inline:28px}
 :host([data-sale-picker]) .product-heading .product-title{font-size:39px}
 :host([data-sale-picker]) .sale-picker-offer{padding:13px 12px;gap:9px}
 :host([data-sale-picker]) .sale-picker-offer>div:first-child{gap:8px}
 :host([data-sale-picker]) .sale-picker-badge{font-size:10px;padding:9px 6px}
 :host([data-sale-picker]) .sale-picker-copy b{font-size:11px}
 :host([data-sale-picker]) .sale-picker-copy small{font-size:9px}
 :host([data-sale-picker]) .sale-pack-content{padding:16px 9px 13px}
 :host([data-sale-picker]) .pack-option .pack-top{font-size:15px}
 :host([data-sale-picker]) .pack-pricing{font-size:28px}
 :host([data-sale-picker]) .pack-use{font-size:9px}
 :host([data-sale-picker]) .unit-price{font-size:10px}
}
@container(max-width:700px){
 :host([data-sale-picker]) .picker{display:flex;flex-direction:column;padding:16px 20px 24px;gap:0}
 :host([data-sale-picker]) .product-heading{margin-bottom:24px;width:100%}
 :host([data-sale-picker]) .product-heading .eyebrow{font-size:9px;letter-spacing:1.5px}
 :host([data-sale-picker]) .product-heading .product-title{font-size:39px;margin:10px 0}
 :host([data-sale-picker]) .sale-picker-intro{font-size:12px}
 :host([data-sale-picker]) .rating{font-size:11px;margin-top:13px;gap:8px}
 :host([data-sale-picker]) .rating a{font-size:10px}
 :host([data-sale-picker]) .sale-picker-offer{margin-top:22px;padding:13px 12px;gap:10px;border-radius:9px}
 :host([data-sale-picker]) .sale-picker-offer>div:first-child{gap:9px}
 :host([data-sale-picker]) .sale-picker-badge{font-size:10px;padding:10px 7px}
 :host([data-sale-picker]) .sale-picker-copy b{font-size:11px}
 :host([data-sale-picker]) .sale-picker-copy small{font-size:9px;line-height:1.5;max-width:115px}
 :host([data-sale-picker]) .sale-picker-deadline>b{font-size:9px}
 :host([data-sale-picker]) .sale-picker-countdown{font-size:11px}
 :host([data-sale-picker]) .pack-section{width:100%;margin-bottom:23px}
 :host([data-sale-picker]) .pack-section legend{font-size:15px;margin-bottom:19px}
 :host([data-sale-picker]) .sale-picker-pack-note{font-size:9px}
 :host([data-sale-picker]) .pack-options{gap:8px}
 :host([data-sale-picker]) .sale-pack-content{padding:16px 9px 13px}
 :host([data-sale-picker]) .pack-option .pack-top{font-size:15px;line-height:1.2}
 :host([data-sale-picker]) .pack-check{font-size:13px}
 :host([data-sale-picker]) .pack-use{font-size:8px;margin-top:7px;min-height:0}
 :host([data-sale-picker]) .sale-former-price{font-size:16px;margin:17px 0 4px}
 :host([data-sale-picker]) .pack-pricing{font-size:27px;letter-spacing:-1px;line-height:1.1;margin:0}
 :host([data-sale-picker]) .unit-price{font-size:9px;margin:7px 0 0}
 :host([data-sale-picker]) .sale-pack-saving{font-size:10px;padding:9px 4px}
 :host([data-sale-picker]) .value-badge{font-size:8px;right:7px;left:auto;top:-9px;padding:4px 6px}
 :host([data-sale-picker]) .pack-foot{padding:14px 0 0!important;font-size:10px}
 :host([data-sale-picker]) #savings{font-size:10px}
 :host([data-sale-picker]) .visual-column{position:static!important;width:100%;height:auto!important;min-height:0;margin:0 0 25px;padding:0;pointer-events:auto}
 :host([data-sale-picker]) .visual-column .set-card{width:100%;height:auto;aspect-ratio:1}
 :host([data-sale-picker]) .visual-column .set-card-top{padding:16px 13px;font-size:10px}
 :host([data-sale-picker]) .visual-column .live-indicator{font-size:9px}
 :host([data-sale-picker]) .visual-column>.mode-options{margin:12px 0 0}
 :host([data-sale-picker]) .sale-picker-photo-note{font-size:9px}
 :host([data-sale-picker]) .controls{width:100%}
 :host([data-sale-picker]) .controls .color-section{padding-top:19px}
 :host([data-sale-picker]) .color-section h2{font-size:15px;margin-bottom:20px}
 :host([data-sale-picker]) .palette{grid-template-columns:repeat(6,minmax(0,1fr));gap:24px 7px}
 :host([data-sale-picker]) .swatch{font-size:10px;gap:10px;min-height:0}
 :host([data-sale-picker]) .swatch-color{width:39px;height:39px}
 :host([data-sale-picker]) .color-workspace .swatch{font-size:10px}
 :host([data-sale-picker]) .color-workspace .swatch-color{width:39px;height:39px}
 :host([data-sale-picker]) .engraving summary{padding:18px 13px}
}
@container(max-width:360px){
 :host([data-sale-picker]) .picker{padding-inline:15px}
 :host([data-sale-picker]) .pack-options{gap:7px}
 :host([data-sale-picker]) .sale-pack-content{padding-inline:7px}
 :host([data-sale-picker]) .sale-former-price{font-size:15px}
 :host([data-sale-picker]) .pack-pricing{font-size:24px}
 :host([data-sale-picker]) .pack-use{font-size:7.5px}
 :host([data-sale-picker]) .pack-option .pack-top{font-size:14px}
 :host([data-sale-picker]) .unit-price{font-size:8px}
 :host([data-sale-picker]) .sale-pack-saving{font-size:9px}
 :host([data-sale-picker]) .sale-picker-pack-note{font-size:8px}
 :host([data-sale-picker]) .sale-picker-offer{padding:11px 9px;gap:6px}
 :host([data-sale-picker]) .sale-picker-offer>div:first-child{gap:7px}
 :host([data-sale-picker]) .sale-picker-copy small{font-size:8px}
 :host([data-sale-picker]) .sale-picker-badge{font-size:9px}
 :host([data-sale-picker]) .sale-picker-copy b{font-size:10px}
 :host([data-sale-picker]) .sale-picker-deadline>b{font-size:8px}
}
@media(prefers-reduced-motion:reduce){:host([data-sale-picker]) .pack-option{transition:none}}
`;
  function mount() {
    const host = document.getElementById('steadi-live-picker');
    const root = host?.shadowRoot;
    if (host?.dataset.ready !== 'true' || !root?.querySelector('.pack-option') || mounted.has(root)) return;
    mounted.add(root);
    host.dataset.salePicker = config.release;
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(css);
    root.adoptedStyleSheets = [...root.adoptedStyleSheets, sheet];
    const heading = root.querySelector('.product-heading');
    const intro = document.createElement('p');
    intro.className = 'sale-picker-intro';
    intro.textContent = 'Your favorite colors. A name that makes it yours.';
    heading.querySelector('.product-title').after(intro);
    const offer = document.createElement('div');
    offer.className = 'sale-picker-offer';
    offer.innerHTML = '<div><span class="sale-picker-badge">25% OFF</span><span class="sale-picker-copy"><b>The weekend sale</b><small>Every pack. Applied automatically.</small></span></div><div class="sale-picker-deadline"><b></b><span class="sale-picker-countdown" aria-label="Time remaining in the sale"></span><small>11:59 PM Pacific</small></div>';
    offer.querySelector('.sale-picker-deadline>b').textContent = 'Ends ' + config.endLabel;
    heading.append(offer);
    const packNote = document.createElement('small');
    packNote.className = 'sale-picker-pack-note';
    packNote.textContent = 'Mix colors in any pack';
    root.querySelector('.pack-section legend').append(packNote);
    for (const label of root.querySelectorAll('.pack-option')) {
      const content = document.createElement('span');
      content.className = 'sale-pack-content';
      const former = document.createElement('span');
      former.className = 'sale-former-price';
      former.innerHTML = '<s></s>';
      content.append(label.querySelector('.pack-top'), label.querySelector('.pack-use'), former, label.querySelector('.pack-pricing'), label.querySelector('.unit-price'));
      const savings = document.createElement('span');
      savings.className = 'sale-pack-saving';
      label.append(content, savings);
    }
    const shippingIcon = document.createElement('span');
    shippingIcon.className = 'sale-shipping-icon';
    shippingIcon.setAttribute('aria-hidden', 'true');
    shippingIcon.innerHTML = '<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 6h11v11H3zM14 10h4l3 4v3h-7"/><circle cx="7" cy="18" r="2" fill="white"/><circle cx="18" cy="18" r="2" fill="white"/></svg>';
    root.querySelector('#savings').before(shippingIcon);
    const photoNote = document.createElement('p');
    photoNote.className = 'sale-picker-photo-note';
    photoNote.textContent = "Drink containers shown for fit. They're not included.";
    root.querySelector('.visual-column').append(photoNote);
    function refresh() {
      const remaining = Date.parse(config.endsAt) - Date.now();
      const labels = [...root.querySelectorAll('.pack-option')];
      // Fail closed if native catalog prices differ from the reviewed offer.
      const pricesMatch = labels.every(label => {
        const pack = label.querySelector('input').value;
        const price = Math.round(Number(label.querySelector('.pack-price').textContent.replace(/[^0-9.]/g, '')) * 100);
        return price === config.expectedPrices[pack];
      });
      const active = config.saleClaimsEnabled === true && remaining > 0 && pricesMatch;
      host.dataset.saleActive = String(active);
      offer.toggleAttribute('data-sale-hidden', !active);
      for (const label of labels) {
        const input = label.querySelector('input');
        const pack = Number(input.value);
        const current = Math.round(Number(label.querySelector('.pack-price').textContent.replace(/[^0-9.]/g, '')) * 100);
        const reference = Number(config.referencePrices[pack]);
        const former = label.querySelector('.sale-former-price');
        const savings = label.querySelector('.sale-pack-saving');
        former.toggleAttribute('data-sale-hidden', !active);
        former.querySelector('s').textContent = money(reference);
        savings.textContent = active ? 'Save ' + money(reference - current) : money(Math.round(current / pack)) + ' / Steadi';
        label.querySelector('.unit-price').toggleAttribute('data-sale-hidden', !active);
        input.setAttribute('aria-label', pack + '-pack, ' + money(current) + (active ? ', save ' + money(reference - current) : ''));
      }
      const mins = Math.max(0, Math.floor(remaining / 60000));
      offer.querySelector('.sale-picker-countdown').textContent = `${Math.floor(mins / 1440)}d : ${String(Math.floor(mins % 1440 / 60)).padStart(2, '0')}h : ${String(mins % 60).padStart(2, '0')}m`;
      const shipping = root.querySelector('#savings');
      shipping.textContent = '$4.95 U.S. shipping per order. Any pack size.';
    }
    root.addEventListener('steadi:selection-change', () => queueMicrotask(refresh));
    refresh();
    if (!window.Shopify?.designMode) observer.disconnect();
    const timer = setInterval(() => { if (!host.isConnected) { clearInterval(timer); return; } refresh(); }, 15000);
  }
  const observer = new MutationObserver(mount);
  observer.observe(document.documentElement, {childList:true, subtree:true, attributes:true, attributeFilter:['data-ready']});
  document.addEventListener('shopify:section:load', mount);
  mount();
})();
